import { VENDOR, type VendorCode } from './vendorDisplayName'

/** Short UI labels for Autonomics robot types (tables, headers, dropdowns). */
const AUTONOMICS_TYPE_SHORT: Record<string, string> = {
  Sweeper: 'Sweeper',
  Combo: 'Combo',
  ComboOmni: 'Omni',
}

/** Full product names (service reports, formal copy). Keep in sync with API display_name. */
const AUTONOMICS_TYPE_FULL: Record<string, string> = {
  Sweeper: 'Autonomics Sweeper',
  Combo: 'Autonomics Combo',
  ComboOmni: 'Autonomics Omni',
}

const GAUSIUM_TYPE_DISPLAY: Record<string, string> = {
  '75': 'Gausium Scrubber 75',
  '50': 'Gausium Omnie',
  '40': 'Gausium Vacuum 40',
  S: 'Gausium Phantas',
}

const ASBIS_TYPE_DISPLAY: Record<string, string> = {
  warehouse: 'Asbis Warehouse',
  welder: 'Asbis Welder',
}

/**
 * Robot models with a scrubber brush: Autonomics Combo and Autonomics Omni.
 * These robots can also choose a cleaning type (Sweeper, Combo, Scrubber) per zone.
 * Cleaning type is a separate field and is not one of these codes.
 */
const COMBO_OR_OMNI_ROBOT_CODES = new Set(['Combo', 'ComboOmni'])

export function isComboOrOmniRobotType(robotType?: string | null): boolean {
  return COMBO_OR_OMNI_ROBOT_CODES.has((robotType || '').trim())
}

/** Compact label for UI lists and headers. Autonomics: Sweeper / Combo / Omni. */
export function getRobotTypeDisplayName(
  vendor: VendorCode | string | undefined,
  typeCode: string | null | undefined
): string {
  const code = (typeCode || '').trim()
  if (!code || code === 'Unknown') return ''

  if (vendor === VENDOR.AUTONOMICS) {
    return AUTONOMICS_TYPE_SHORT[code] || code
  }

  if (vendor === VENDOR.GAUSIUM) {
    return GAUSIUM_TYPE_DISPLAY[code] || code
  }

  if (vendor === VENDOR.ASBIS) {
    return ASBIS_TYPE_DISPLAY[code] || code
  }

  return code
}

/** Full product name (e.g. service report RobotModel). */
export function getRobotTypeFullDisplayName(
  vendor: VendorCode | string | undefined,
  typeCode: string | null | undefined
): string {
  const code = (typeCode || '').trim()
  if (!code || code === 'Unknown') return ''

  if (vendor === VENDOR.AUTONOMICS) {
    return AUTONOMICS_TYPE_FULL[code] || code
  }

  return getRobotTypeDisplayName(vendor, code)
}
